<template>
  <div>
    <!-- Modal de Lançamento -->
    <div
      class="modal fade"
      id="lancamentoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="lancamento">
          <div class="modal-header">
            <h5 class="modal-title">Criar Lançamento/Baixa</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
             <div class="row">
                <div class="col col-12 col-md-12">
                  <az-input
                    label="Unidade"
                    type="select"
                    placeholder="Todas"
                    :optionsList="$store.state.unidade.unidade_operacaos"
                    optionsData="id_unidade_operacao"
                    required
                    :validate="validate"
                    :edicao="conciliacaoData && conciliacaoData.conta && conciliacaoData.conta.id_unidade_operacao == null"
                    v-model="lancamento.id_unidade_operacao" />
                </div>
            </div>
            <div class="row">
                <div class="col col-12 col-md-12" v-if="lista_centros.length > 1">
                    <az-input
                        sizing="sm"
                        label="Centro de Custo"
                        type="select"
                        placeholder="Selecione..."
                        :optionsList="lista_centros"
                        optionsData="id_centro_custo"
                        :validate="validate"
                        v-model="lancamento.id_centro_custo">
                    </az-input>
                </div>
            </div>
            <div class="row">
              <div class="col col-12 col-md-12">
                <selecao-categoria
                  v-model="lancamento.id_categoria"
                  :validate="validate"
                  :ch_tipo_lancamento="lancamento.ch_tipo_lancamento" />

                <az-input
                  v-if="false"
                  label="Categoria"
                  :validate="validate"
                  required
                  type="select"
                  optionsMode="aql"
                  service="categorias.index"
                  :optionsName="'categorias.' + ( lancamento ? lancamento.ch_tipo_lancamento : 'X' )"
                  optionsData="id_categoria"
                  optionsDisplay="search"
                  :optionsParm="{ lancamento: true, where: { ch_natureza: lancamento ? lancamento.ch_tipo_lancamento : '?' } }"
                  v-model="lancamento.id_categoria"
                />
              </div>
            </div>

            <div class="row">
              <div class="col col-12 col-md-12">
                <az-input
                    v-if="conciliacaoItemSelecionado && conciliacaoItemSelecionado.tipo == 'D'"
                    label="Fornecedor"
                    :validate="validate"
                    type="autocomplete"
                    optionsMode="aql"
                    service="fornecedores.index"
                    optionsData="id_fornecedor"
                    optionsDisplay="search"
                    v-model="lancamento.id_fornecedor_debito" />
                <az-input
                    v-else-if="conciliacaoItemSelecionado && conciliacaoItemSelecionado.tipo == 'C'"
                    label="Cliente"
                    type="select" 
                    optionsMode="aql"
                    optionsData="id_operadora"
                    optionsDisplay="st_operadora"
                    :optionsParms="{ fatura: true }"
                    service="operadoras.index"
                    optionsName="operadoras-para-fatura"
                    placeholder="Não informado."
                    v-model="lancamento.id_operadora">
                </az-input>
              </div>
            </div>

            <div class="row">
              <div class="col col-12 col-md-12">
                <az-input
                  label="Forma de Pagamento"
                  :validate="validate"
                  required
                  type="select"
                  optionsMode="aql"
                  service="forma_pagamentos.index"
                  optionsData="id_forma_pagamento"
                  optionsDisplay="search"
                  v-model="lancamento.id_forma_pagamento"
                />
              </div>
            </div>
            <div class="row">
              <div class="col col-12 col-md-12">
                <az-input
                  label="Descrição"
                  :validate="validate"
                  required
                  v-model="lancamento.st_descricao"
                />
              </div>
            </div>
            <div class="row" v-if="conciliacaoItemSelecionado">
              <div class="col col-12 col-md-6">
                <div>Tipo</div>
                <div
                  class="lead"
                  :class="(conciliacaoItemSelecionado.TRNTYPE == 'DEP' || conciliacaoItemSelecionado.TRNTYPE == 'CREDIT' || conciliacaoItemSelecionado.TRNTYPE == 'XFER') ? 'text-primary' : 'text-danger'"
                >
                  <strong>{{transacao_selecionada_tipo}}</strong>
                </div>
              </div>
              <div class="col col-12 col-md-6">
                <div>Conta</div>
                <div class="lead">
                  <strong>{{conciliacaoData.conta.st_conta}}</strong>
                </div>
              </div>
            </div>
            <div class="row" v-if="conciliacaoItemSelecionado">
              <div class="col col-12 col-md-12">
                <div>Conta</div>
                <div
                  class="lead"
                  :class="(conciliacaoItemSelecionado.TRNTYPE == 'DEP' || conciliacaoItemSelecionado.TRNTYPE == 'CREDIT' || conciliacaoItemSelecionado.TRNTYPE == 'XFER') ? 'text-primary' : 'text-danger'"
                >
                  <strong>{{$util.formatMoeda(conciliacaoItemSelecionado.TRNAMT)}}</strong>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="salvarLancamento ()">Salvar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Filtro -->
    <div class="card dashcard mb-0">
      <div class="card-body">
        <div class="row">
          <div class="col col-12 col-md-4">
            <az-input
              placeholder="Selecione uma conta"
              icon="fas fa-money-check-alt"
              type="select"
              optionsMode="aql"
              service="contas.index"
              optionsData="id_conta"
              optionsDisplay="search"
              :optionsParm="{ ativas: true }"
              v-model="filtro.id_conta"
              required
              :validate="validate"
            />
          </div>

          <div class="col col-12 col-md-4 d-flex flex-column">
            <az-submit color="outline-primary" @click="upload()">Carregar Arquivo</az-submit>
          </div>
        </div>
      </div>
    </div>

    <div class="progress mt-1 mb-3">
      <div class="indeterminate" v-if="$store.state.loading && conciliacaoData"></div>
      <div class="determinate" v-else></div>
    </div>

    <template v-if="conciliacaoData">
      <div class="card-deck">
        <!-- Extrato -->
        <div class="card carde overflow-auto" style="padding: 0px; height: 60vh;">
          <div class="card-body">
            <h5 class="card-title">Informações do Extrato bancário</h5>
            <table class="table table-responsive-md table-hover bg-light table-sm" v-if="conciliacaoData && conciliacaoData.transacoes">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Descrição</th>
                  <th class="text-right">Valor</th>
                  <th class="text-center">Conciliar</th>
                </tr>
              </thead>
              <tbody>
                <!-- Extrato -->
                <template v-for="(transacao, ig) in conciliacaoData.transacoes">
                  <tr :key="ig" :class="conciliacaoItemSelecionado && conciliacaoItemSelecionado.FITID == transacao.FITID && conciliacaoItemSelecionado.DTPOSTED == transacao.DTPOSTED && conciliacaoItemSelecionado.TRNAMT == transacao.TRNAMT  ? 'bg-secondary text-light' : 'table-light'">
                    <td>{{ $util.getFormatDate(transacao.DTPOSTED) }}</td>
                    <td>{{ transacao.MEMO }}</td>
                    <td
                      class="text-right"
                      class2="(transacao.TRNTYPE == 'DEP' || transacao.TRNTYPE == 'CREDIT' || transacao.TRNTYPE == 'XFER') ? 'text-primary' : 'text-danger'"
                      :class="transacao.tipo == 'D' ? 'text-danger' : 'text-primary'"
                    >{{ $util.formatMoeda(transacao.TRNAMT) }}</td>
                    <td class="text-nowrap text-center">
                      <a href="#" @click.prevent="copy_to_console(transacao)" v-if="false">
                        <i class="fas fa-copy"></i>
                      </a>
                      <template v-if="!transacao.conciliado">
                        <a
                          href="#"
                          @click.prevent="conciliarItem(transacao)"
                          v-if="!conciliacaoItemSelecionado || (conciliacaoItemSelecionado && conciliacaoItemSelecionado.FITID == transacao.FITID && conciliacaoItemSelecionado.DTPOSTED == transacao.DTPOSTED && conciliacaoItemSelecionado.TRNAMT == transacao.TRNAMT )"
                        >
                          <i class="fas fa-pen"></i>
                        </a>
                        <i class="fas fa-pen" v-else></i>
                      </template>
                      <template v-else>
                        <a
                          href="#"
                          @click.prevent="conciliarItem(transacao)"
                          v-if="!conciliacaoItemSelecionado || (conciliacaoItemSelecionado && conciliacaoItemSelecionado.FITID == transacao.FITID && conciliacaoItemSelecionado.DTPOSTED == transacao.DTPOSTED && conciliacaoItemSelecionado.TRNAMT == transacao.TRNAMT )"
                        >
                          <i class="fas fa-check-circle text-success"></i>
                        </a>
                        <i class="fas fa-check-circle" v-else></i>
                      </template>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <!--Conciliar Baixas -->
        <div class="card carde"  style="padding: 0px; height: 60vh;" v-if="conciliacaoItemSelecionado">
          <div class="card-body overflow-auto">
            <h5 class="card-title">
              <strong>{{conciliacaoItemSelecionado.MEMO}}</strong>
            </h5>
            <div class="row">
              <div class="col col-12">
                <az-input
                  sizing="sm"
                  icon="fa fa-search"
                  placeholder="Pesquisar..."
                  v-model="conc_search" />
              </div>
            </div>

            <table class="table table-hover table-responsive-md bg-white table-sm" v-if="baixas_selecionadas">
              <thead>
                <tr>
                  <table-th title="" v-model="ordem" sortby="check" v-if="!conciliacaoItemSelecionado.conciliado"></table-th>
                  <table-th title="Data" v-model="ordem" sortby="dt_baixa"></table-th>
                  <table-th title="Descrição" v-model="ordem" sortby="st_descricao"></table-th>
                  <table-th title="Valor" v-model="ordem" sortby="valor_liquido" class="text-right"></table-th>

                </tr>
              </thead>
              <tbody class="small">
                <tr v-for="(item, idx) in baixas_selecionadas_filtradas" :key="idx">
                  <td v-if="!conciliacaoItemSelecionado.conciliado">
                    <input
                      type="checkbox"
                      v-model="item.check" />
                  </td>
                  <td>{{ $util.getFormatDate(item.dt_baixa) }}</td>
                  <td>{{ item.lancamento.st_descricao }}</td>
                  <td
                    class="text-right"
                    :class="item.tipo_lancamento == 'D' ? 'text-danger' : 'text-primary'"
                  >{{ $util.formatMoeda (item.valor_liquido) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer d-flex justify-content-between">
            <div class="small">
              <div>
                Extrato: {{ $util.formatMoeda(conciliacaoItemSelecionado.TRNAMT) }}
              </div>
              <div v-if="!conciliacaoItemSelecionado.conciliado">
                Conciliado: {{ $util.formatMoeda(total_baixas_selecionadas) }}
                <i class="fas fa-check-circle text-success ml-1" v-if="conciliacao_item_ok"></i>
              </div>
            </div>
            <div>
              <template v-if="conciliacaoItemSelecionado.conciliado">
                <button type="button" class="btn btn-sm btn-danger" @click.prevent="cancelarItemSelecionado()">
                  Cancelar
                </button>
                <button type="button" class="btn btn-sm btn-danger ml-2" @click.prevent="removerItemSelecionado()">
                  Remover conciliação
                </button>
              </template>
              <template v-else>
                <button type="button" class="btn btn-sm btn-success mr-2" @click.prevent="criarLancamento()">
                  Criar Lançamento
                </button>
                <button type="button" class="btn btn-sm btn-danger" @click.prevent="cancelarItemSelecionado()">
                  Cancelar
                </button>
                <button type="button" class="btn btn-sm btn-primary ml-2" :disabled="!conciliacao_item_ok" @click.prevent="confirmarConciliacaoItem()">
                  Conciliar
                </button>
              </template>
            </div>
          </div>
        </div>
        <!-- Resumo do extrato -->
        <div class="card carde" v-else>
          <div class="card-body">
            <h5 class="card-title">Informações do arquivo</h5>

            <div class="row mb-2">
              <div class="col col-12 col-md-6">
                <div>Conta</div>
                <div class="lead text-primary">
                  <strong>{{conciliacaoData.conta.st_conta}}</strong>
                </div>
              </div>
              <div class="col col-12 col-md-6">
                <div>Período do extrato</div>
                <div class="lead text-primary">
                  <strong>{{resumo_periodo}}</strong>
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col col-12 col-md-6">
                <div>Qtde. itens no extrato</div>
                <div class="lead text-primary">
                  <strong>{{conciliacaoData.transacoes.length}}</strong>
                </div>
              </div>
              <div class="col col-12 col-md-6">
                <div>Qtde. baixas não concliadas</div>
                <div class="lead text-primary">
                  <strong>{{conciliacaoData.baixas.length}}</strong>
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col col-12 col-md-6">
                <div>Total créditos no extrato</div>
                <div class="lead text-success">
                  <strong>{{$util.formatMoeda(resumo_total_creditos)}}</strong>
                </div>
              </div>
              <div class="col col-12 col-md-6">
                <div>Total débitos no extrato</div>
                <div class="lead text-danger">
                  <strong>{{$util.formatMoeda(resumo_total_debitos)}}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <az-empty-state />
    </template>
  </div>
</template>

<script>
// import * as moment from "moment";
import _ from "lodash";
import $ from "jquery";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import SelecaoCategoria from './SelecaoCategoria.vue';
import TableTh from '../../shared/table/TableTh.vue';

export default {
  data() {
    return {
      conciliacaoData: null,
      conciliacaoItemSelecionado: null,
      lancamento: null,
      validate: false,
      teste: "",
      ordem: "",
      filtro: {
        id_conta: "",
      },
      conc_search: "",
    };
  },
  components: {
    AzInput,
    AzEmptyState,
    AzSubmit,
    SelecaoCategoria,
    TableTh
  },

  methods: {
    comparaValores(v1, v2) {
        let valor1, valor2;

        try {
            valor1 = Math.round(+v1* 100);
        } catch (_) {
            valor1 = v1;
        }

        try {
            valor2 = Math.round(+v2 * 100);
        } catch (_) {
            valor2 = v2;
        }

        return valor1 == valor2;
    },

    copy_to_console (item) {
      console.log(item);
    },

    upload() {
      this.validate = false;
      if(this.filtro && !this.filtro.id_conta) {
        this.validate = true;
        this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Seleciona a conta bancária",
            life: 3000,
          });
        return;
      }

      var downloadAnchorNode = document.createElement("input");
      downloadAnchorNode.setAttribute("type", "file");
      downloadAnchorNode.setAttribute("class", "d-none");
      downloadAnchorNode.onchange = () => {
        this.posUpload(downloadAnchorNode);
      };
      document.body.appendChild(downloadAnchorNode);
      downloadAnchorNode.click();
    },
    posUpload(el) {
      var file = el.files[0];
      if (file) {
        var reader = new FileReader();

        reader.readAsText(file, "ISO-8859-1");

        reader.onload = (evt) => {
            this.$util
                .load(this, {
                    service: "financeiro.conciliacao",
                    func: "conciliacao",
                    redir_api: true,
                    parms: {
                        json: evt.target.result,
                        id_conta: this.filtro.id_conta,
                    },
                    loadTo: (res) => {
                        this.conciliacaoData = res;
                    },
                });
            // .then((res) => {
            //   this.conciliacaoData = res;
            // })
            // .finally(() => {
            //   this.$store.commit('loading', false);
            // });
        };

        reader.onerror = function () {
          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Falha lendo arquivo.",
            life: 3000,
          });
        };
      }
    },
    conciliarItem(transacao) {
      this.conc_search = "";
      this.conciliacaoItemSelecionado = transacao;

      if (!this.conciliacaoItemSelecionado.conciliado)
        this.baixas_selecionadas.forEach((item) => {
          item.check =
            this.$util.getFormatDate(
              this.conciliacaoItemSelecionado.DTPOSTED
            ) == this.$util.getFormatDate(item.dt_baixa) &&
            this.comparaValores(this.conciliacaoItemSelecionado.TRNAMT, item.valor_liquido);
            // this.conciliacaoItemSelecionado.TRNAMT == item.valor_liquido;
        });
    },
    cancelarItemSelecionado() {
      if (!this.conciliacaoItemSelecionado.conciliado)
        this.baixas_selecionadas.forEach((item) => {
          item.check = false;
        });
      this.resetSelecionado();
    },
    removerItemSelecionado() {
      const key = this.conciliacaoItemSelecionado.KEY;

      this.$util.atualizar(this, {
        service: "financeiro",
        func: "remover_conciliar_baixa",
        dados: {
          baixas: this.baixas_selecionadas,
        },
        toast: true,
        callback: () => {
          this.baixas_selecionadas
            .filter((item) => item.conciliacao_key == key)
            .forEach((item) => {
              item.st_conciliacao_fitid = "";
              item.conciliacao_key = "";
            });
          this.conciliacaoItemSelecionado.conciliado = false;
          this.resetSelecionado();
        },
      });
    },
    confirmarConciliacaoItem() {
      this.$util.atualizar(this, {
        service: "financeiro",
        func: "conciliar_baixa",
        dados: {
        //   baixas: this.baixas_selecionadas,
          baixas: this.baixas_selecionadas.filter((item) => item.check),
          fitid: this.conciliacaoItemSelecionado.FITID,
          data_conciliacao: this.conciliacaoItemSelecionado.DTPOSTED,
          memo: this.conciliacaoItemSelecionado.MEMO,
          checknum: Array.isArray(this.conciliacaoItemSelecionado.CHECKNUM)
            ? this.conciliacaoItemSelecionado.CHECKNUM[0]
            : this.conciliacaoItemSelecionado.CHECKNUM,
          key: this.conciliacaoItemSelecionado.KEY,
        },
        callback: (res) => {
          if (res && res.original.status_code >= 400) {
            this.$toast.add({
              severity: "error",
              summary: "Conciliação",
              detail: res ? res.original.msg : "Erro ao conciliar baixa.",
              life: 5000,
            });
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Conciliação",
              detail: "Conciliação realizada com sucesso.",
              life: 3000,
            });

            const fitid = this.conciliacaoItemSelecionado.FITID;
            const checkNum = Array.isArray(this.conciliacaoItemSelecionado.CHECKNUM)
                ? this.conciliacaoItemSelecionado.CHECKNUM[0]
                : this.conciliacaoItemSelecionado.CHECKNUM;
            const key = this.conciliacaoItemSelecionado.KEY;

            this.baixas_selecionadas
              .filter((item) => item.check)
              .forEach((item) => {
                item.st_conciliacao_fitid = fitid;
                item.st_conciliacao_checknum = checkNum;
                item.conciliacao_key = key;
              });
            this.conciliacaoItemSelecionado.conciliado = true;
            this.resetSelecionado();
          }
        },
      });
    },
    criarLancamento() {
      this.lancamento =  null;
      this.validate = false;

      this.$nextTick(() => {
        this.lancamento = {
            id_lancamento: null,
            id_categoria: null,
            id_forma_pagamento: null,
            dc_valor: this.conciliacaoItemSelecionado.TRNAMT,
            dt_competencia: this.$util.getFormatDate(
            this.conciliacaoItemSelecionado.DTPOSTED,
            "YYYY-MM"
            ),
            dt_emissao: this.$util.getFormatDate(
            this.conciliacaoItemSelecionado.DTPOSTED,
            "YYYY-MM-DD"
            ),
            dt_vencimento: this.$util.getFormatDate(
            this.conciliacaoItemSelecionado.DTPOSTED,
            "YYYY-MM-DD"
            ),
            st_descricao: this.conciliacaoItemSelecionado.MEMO
                ? this.conciliacaoItemSelecionado.MEMO
                : this.$util.getFormatDate(this.conciliacaoItemSelecionado.DTPOSTED, "YYYY-MM-DD"),
            ch_tipo_lancamento: this.conciliacaoItemSelecionado.tipo,
            ch_estado: "A",
            recorrente: false,
            //quantidade: 12,
            tipo_lanc: "R",
            id_conta_baixa: this.conciliacaoData.conta.id_conta,
            id_unidade_operacao: this.conciliacaoData.conta.id_unidade_operacao,
        };

        $("#lancamentoModal").modal("show");
      });
    },
    salvarLancamento() {
      let dados = { ...this.lancamento };
      dados.dt_competencia = dados.dt_competencia.substr(0, 7);
      dados.conciliado = true;
      dados.data_conciliacao = this.conciliacaoItemSelecionado.DTPOSTED;
      dados.fitid = this.conciliacaoItemSelecionado.FITID;
      dados.checknum = Array.isArray(this.conciliacaoItemSelecionado.CHECKNUM)
        ? this.conciliacaoItemSelecionado.CHECKNUM[0]
        : this.conciliacaoItemSelecionado.CHECKNUM;
      dados.memo = this.conciliacaoItemSelecionado.MEMO;
      dados.key = this.conciliacaoItemSelecionado.KEY;

      this.$util.atualizar(this, {
        service: "financeiro",
        func: "store",
        dados: dados,
        modal: "lancamentoModal",
        toast: true,
        callback: (res) => {
          this.conciliacaoData.baixas.push(res);
          this.conciliacaoItemSelecionado.conciliado = true;
          this.resetSelecionado();
        },
      });
    },
    resetSelecionado() {
      this.conciliacaoItemSelecionado = null;
    },
  },
  computed: {
    lista_centros: function() {
      if (!this.conciliacaoData.conta.id_unidade_operacao) return [];

      let und = this.$store.state.unidade.unidade_operacaos.find(
          item =>
              item.id_unidade_operacao == this.conciliacaoData.conta.id_unidade_operacao
      );

      return und ? und.centro_custos : [];
    },

    base_baixas_selecionadas: function () {
      if (!this.conciliacaoItemSelecionado || !this.conciliacaoData || !this.conciliacaoData.baixas ) {
        return [];
      }

      return this.conciliacaoData.baixas.filter((item) => {
        let conciliado = this.conciliacaoItemSelecionado.conciliado
          ? item.conciliacao_key == this.conciliacaoItemSelecionado.KEY
          : ( item.tipo_lancamento == this.conciliacaoItemSelecionado.tipo && !item.st_conciliacao_fitid );

        if(conciliado == false && this.conciliacaoItemSelecionado.conciliado && this.conciliacaoItemSelecionado.conciliado_old) {
            conciliado = ( item.conciliacao_key == this.conciliacaoItemSelecionado.KEY_OLD );
        }

        return conciliado;
      });

    },

    baixas_selecionadas_filtradas: function () {
      const reg = this.$util.getregex(this.conc_search);
      return this.baixas_selecionadas.filter(item => !this.conc_search || reg.test(JSON.stringify(item)));
    },

    baixas_selecionadas: function () {
      if (!this.conciliacaoItemSelecionado)
        return null;

      let baixas = this.base_baixas_selecionadas;

      if ( this.ordem ) {
          baixas = _.sortBy(baixas, (item) => {
              return _.get(item, this.ordem.name );
          });

          if ( this.ordem.direction == 'desc' ) {
              baixas = _.reverse(baixas);
          }
      }

      return baixas;
    },

    total_baixas_selecionadas: function () {
      return !this.baixas_selecionadas
        ? 0
        : this.baixas_selecionadas.reduce((total, item) => {
            return total + (item.check ? item.valor_liquido : 0);
          }, 0);
    },

    conciliacao_item_ok: function () {
      let valor1, valor2;

      try {
        valor1 = Math.round(+this.conciliacaoItemSelecionado.TRNAMT * 100);
      } catch (_) {
        valor1 = this.conciliacaoItemSelecionado.TRNAMT;
      }

       try {
        valor2 = Math.round(+this.total_baixas_selecionadas * 100);
      } catch (_) {
        valor2 = this.total_baixas_selecionadas;
      }

      return (
        this.conciliacaoItemSelecionado &&
        this.baixas_selecionadas &&
            valor1 == valor2
      );
    },

    resumo_total_creditos: function () {
      if (!this.conciliacaoData) return 0;
      if (!this.conciliacaoData.transacoes) return 0;
      return this.conciliacaoData.transacoes.reduce((total, item) => {
        return total + (item.tipo == "C" ? item.TRNAMT : 0);
      }, 0);
    },

    resumo_total_debitos: function () {
      if (!this.conciliacaoData) return 0;
      if (!this.conciliacaoData.transacoes) return 0;
      return this.conciliacaoData.transacoes.reduce((total, item) => {
        return total + (item.tipo == "D" ? item.TRNAMT : 0);
      }, 0);
    },

    resumo_periodo: function () {
      if (!this.conciliacaoData) return "";
      if (!this.conciliacaoData.transacoes) return "";

      const inicio = _.first(this.conciliacaoData.transacoes);
      const fim = _.last(this.conciliacaoData.transacoes);
      return inicio && fim
        ? this.$util.getFormatDate(inicio.DTPOSTED) +
            " a " +
            this.$util.getFormatDate(fim.DTPOSTED)
        : "";
    },
    transacao_selecionada_tipo: function () {
      return this.conciliacaoItemSelecionado
        ? this.conciliacaoItemSelecionado.tipo == "C"
          ? "Crédito"
          : "Débito"
        : "";
    },

    total_selecionado_para_conciliar: function () {
      return this.base_baixas_selecionadas.filter(item => item.check)
        .reduce((total, carry) => {
          return total + parseFloat(carry.valor_liquido);
        }, 0);
    }
  },

  mounted() {
    this.$store.commit("setBreadcrumb", [
      { name: "Financeiro", path: "/financeiro" },
      { name: "Conciliação bancária", path: "/financeiro/conciliacao" },
    ]);
  },
};
</script>
